module.exports = __webpack_public_path__ + "img/qanda03.cddcdab.webp";